import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import { formatMoney } from '../../Shared/Formatters';
import { useApexTheme } from './useApexTheme';

/**
 * Small donut for top-categories in the briefing block.
 */
export default function CategoryPie({ title, items, dir = 'ltr' }) {
    const palette = useApexTheme();
    const safeItems = Array.isArray(items) ? items.filter(i => Number(i.value) > 0) : [];

    const { labels, values } = useMemo(() => ({
        labels: safeItems.map(i => i.name || '—'),
        values: safeItems.map(i => Number(i.value) || 0),
    }), [safeItems]);

    if (!values.length) return null;

    const options = {
        chart: {
            type: 'donut',
            fontFamily: 'Inter, system-ui',
            background: 'transparent',
            rtl: dir === 'rtl',
            animations: { enabled: true, speed: 400 },
        },
        labels,
        colors: palette,
        legend: {
            position: 'bottom',
            fontSize: '11px',
            labels: { colors: 'var(--v3-text-secondary)' },
            markers: { width: 8, height: 8, radius: 2 },
            itemMargin: { vertical: 2, horizontal: 6 },
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => `${Number(val).toFixed(0)}%`,
            style: { fontSize: '10px', fontWeight: 700, colors: ['#ffffff'] },
            dropShadow: { enabled: true, blur: 2, opacity: 0.45 },
        },
        plotOptions: {
            pie: {
                expandOnClick: false,
                donut: {
                    size: '62%',
                    labels: {
                        show: true,
                        value: {
                            fontSize: '13px',
                            fontWeight: 700,
                            color: 'var(--v3-text-primary)',
                            formatter: (val) => formatMoney(val),
                        },
                        total: {
                            show: true,
                            label: '',
                            color: 'var(--v3-text-muted)',
                            formatter: (w) => formatMoney(w.globals.seriesTotals.reduce((a, b) => a + b, 0)),
                        },
                    },
                },
            },
        },
        stroke: { width: 2, colors: ['transparent'] },
        tooltip: {
            theme: 'dark',
            y: { formatter: (v) => formatMoney(v) },
        },
    };

    return (
        <div className="chat-block">
            {title && <div className="chat-block-title">{title}</div>}
            <Chart type="donut" options={options} series={values} height={200} />
        </div>
    );
}
